// extracted by extract-css-chunks-webpack-plugin
module.exports = {"RichText__anchor":"RichText__anchor"};